import { useCallback } from 'react'
import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { Organization } from 'organization/types'

export default function useGetOrganization(): [
  (organizationId: number) => Promise<Organization>,
  Status<Organization>,
] {
  const [request, status] = useFetchRefactored<Organization>()

  const getOrganization = useCallback(
    async (organizationId: number) =>
      request({
        method: 'get',
        url: `/organizations/${organizationId}`,
      }),
    [request],
  )

  return [getOrganization, status]
}
